import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "../../constants";
import type { DeviceAllowedCodeLength } from "../../types";
import { removeSpacesFromCode } from "../formatters/registrationCode";
import { getIsEvo } from "../isEvo";
import { isNonEmptyString } from "../isNonEmptyString";

const SUCCESS_STATUS = 200;
const LEGACY_SUCCESS_STATUS = 202;

export const getIsDeviceHasCorrectLength = ({
  deviceCode,
  allowedLengths = DEFAULT_ALLOWED_DEVICE_CODE_LENGTH,
}: {
  deviceCode: string;
  allowedLengths?: DeviceAllowedCodeLength[];
}) => {
  const formattedCode = removeSpacesFromCode(deviceCode);

  return allowedLengths.includes(formattedCode.length as DeviceAllowedCodeLength);
};

export const resolveRegistrationStatus = (
  statusCode: number,
  isUseEvoOnly: boolean = false,
  deviceServiceUrl?: string
): number => {
  const isEvoServiceApiUrlUsed = isNonEmptyString(deviceServiceUrl) && getIsEvo(deviceServiceUrl);
  const isEvoApiUsed = Boolean(isUseEvoOnly || isEvoServiceApiUrlUsed);

  if (!isEvoApiUsed) {
    return statusCode;
  }

  return statusCode === SUCCESS_STATUS ? LEGACY_SUCCESS_STATUS : statusCode;
};
